











































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import {
  TableHeader,
  PaginationItem,
  ProblemDTO,
  ErrorHeader,
  PaginationSync,
} from '@/customTypes';
import ProblemService from '../services/problem';
@Component({
  filters: {
    formatDate(date: Date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
  },
})
export default class ProblemsTable extends Vue {
  public headers: TableHeader[];
  public problems: ProblemDTO[];
  public search: string;
  public rowsPerPageItems: PaginationItem[];
  public selectedProblems: ProblemDTO[];
  public loadingProblems: boolean;
  public refreshSnackBar: boolean;
  public snackBarColour: string;
  public snackBarTimeout: number = 2500;
  public snackBarResult: [number, number];
  public paginationSync: PaginationSync = {
    descending: true,
    sortBy: 'statusDate',
  } as PaginationSync;

  private problemService: ProblemService;

  constructor() {
    super();

    this.problems = [];
    this.selectedProblems = [];
    this.loadingProblems = false;
    this.refreshSnackBar = false;
    this.snackBarColour = 'success';
    this.snackBarResult = [0, 0];

    this.problemService = new ProblemService();

    this.search = '';
    this.rowsPerPageItems = [
      { text: '15', value: 15 },
      { text: '25', value: 25 },
      { text: '50', value: 50 },
      { text: '100', value: 100 },
      { text: 'All', value: -1 },
    ];

    this.headers = [
      { text: 'Name', value: 'documentName', align: 'left' },
      { text: 'Date', value: 'statusDate', align: 'left', sortable: true },
      { text: 'File', value: 'fileName', align: 'left' },
      { text: 'File Date', value: 'fileDate', align: 'left' },
      { text: 'Error type', value: 'errorType', align: 'left' },
    ];
  }
  public async created() {
    await this.loadProblems();
  }

  public async refreshCalls() {
    this.loadingProblems = true;
    const errors = this.selectedProblems.map((p) => p.header);
    const resolutions = await this.problemService.resolveUserProblems(errors);
    const result = resolutions.reduce<[number, number]>(
      (p, c) => [
        p[0] + (c.result.resolved ? 1 : 0),
        p[1] + (c.result.resolved ? 0 : 1),
      ],
      [0, 0],
    );
    this.snackBarResult = result;
    this.snackBarColour = result[1] > 0 ? 'error' : 'success';
    this.refreshSnackBar = true;
    this.problems = await this.problemService.getProblems();
    this.loadingProblems = false;
  }

  public async loadProblems() {
    this.loadingProblems = true;
    this.problems = await this.problemService.getProblems();
    this.loadingProblems = false;
  }
}
